import { useEffect, useState } from 'react';
import { BsFillPlayFill } from 'react-icons/bs';
import CardH from 'src/components/cards-video/card-h';
import { APP_IMG } from 'src/constants';
import Dailymotion from 'react-dailymotion';
import _ from 'lodash';
import { FiArrowRightCircle } from 'react-icons/fi';

const SecFullH = ({ data = [], eventDataLayer }) => {
  const [defalutData, setDefalutData] = useState({
    video_type: '',
    video_src: ''
  });
  const dataSetVideo = [data?.block1, data?.block2, data?.block3];
  const [counter, setCounter] = useState(0);
  const [dataItem, setDataItem] = useState(dataSetVideo[0]);
  const [active, setActive] = useState({
    key: 0,
    status: true
  });
  useEffect(() => {
    if (dataItem.data?.length > 0) {
      setDefalutData({ video_type: dataItem.data[0]?.type_video, video_src: dataItem.data[0]?.video_src });
    }
  }, [dataItem]);

  const getVideoIframe = () => {
    let urlVideo;
    if (defalutData.video_type === '0') {
      urlVideo = `${APP_IMG}/${defalutData.video_src}`;
    } else if (defalutData.video_type === '2') {
      urlVideo = defalutData.video_src;
      // urlVideo = defalutData.video_src;
    } else {
      urlVideo = defalutData.video_src;
      // urlVideo = defalutData.video_src;
    }
    // const iframe = `<div class='dailymotion-cpe' video-id='${urlVideo[1]}' />`;

    return (
      <>
        {defalutData.video_type === '4' ? (
          <div dangerouslySetInnerHTML={urlVideo} />
        ) : (
          <>
            {defalutData.video_type === '2' ? (
              <iframe id='video-frame-section' className='video-frame' src={`${urlVideo}?autoplay=0&mute=1`} frameBorder='0' />
            ) : (
              <div className='video-div'>
                <Dailymotion video={urlVideo} width={640} height={480} theme='dark' autoplay={false} />
              </div>
            )}
          </>
        )}
      </>
    );
  };

  return (
    <>
      {!_.isEmpty(dataSetVideo) && (
        <>
          <div className='block-wrapper'>
            <div className='block-title --video'>
              <h2>{'วิดีโอ'}</h2>
              <a href='/live/video' className='more'>
                ดูทั้งหมด <FiArrowRightCircle />
              </a>
            </div>
          </div>
          {!_.isEmpty(dataSetVideo) && (
            <div className='tags-area --homepage-video'>
              <div className='post-tags'>
                {dataSetVideo.map(
                  (item, index) =>
                    _.isArray(item?.data) &&
                    item.data.length > 0 && (
                      <p
                        key={index}
                        className={`${active.status && active.key === index ? 'current' : ''}`}
                        onClick={() => {
                          setDataItem(dataSetVideo[index]);
                          setActive({ key: index, status: true });
                        }}
                      >
                        {item.title}
                      </p>
                    )
                )}
              </div>
            </div>
          )}
          <div className='section-wrapper'>
            <div className='row'>
              <div className='col-12 video-player col-md-8'>{!_.isEmpty(dataItem?.data) && getVideoIframe()}</div>
              <div className='col-12 col-md-4 card-wrapper-live'>
                <div className='playlist-head'>
                  <div className='playlist-head-icon'>
                    <BsFillPlayFill />
                  </div>
                  <h2>Most Watched</h2>
                  <span className='videos-number'>
                    <span> {counter + 1} </span> / <span> {dataItem.data?.length} </span> Videos
                  </span>
                </div>
                <div className='video-playlists playlist-custom-scroll --vertical'>
                  <ul>
                    {!_.isEmpty(dataItem?.data) &&
                      dataItem.data.map((item, index) => (
                        <li
                          className={`w-100 ${counter === index ? 'active' : ''}`}
                          key={index}
                          onClick={() => {
                            setDefalutData({
                              video_type: item.type_video,
                              video_src: item.video_src
                            });
                            setCounter(index);
                          }}
                        >
                          <CardH
                            data={item}
                            number={index + 1}
                            //! DATALAYER
                            eventDataLayer={{
                              ...eventDataLayer,
                              data: {
                                ...eventDataLayer?.data,
                                heading: dataSetVideo?.[active?.key]?.title,
                                title: item?.title,
                                index: index + 1
                              }
                            }}
                          />
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SecFullH;
